// Project images and data
export const PROJECTS = [
  {
    id: 1,
    img: "https://i.ibb.co/ctXp9Q1/new-home7.png",
    title: "Alan Ai News App",
    description: "Designed built & maintained an AI News App. You can ask for news by clicking on the mic and navigate through the whole application using voice commands.",
    link: "https://alan-ai-news-app-react.herokuapp.com/",
    isExternal: true
  },
  {
    id: 2,
    img: "https://i.ibb.co/C713f5H/Screenshot-52.png",
    title: "Urban Services",
    description: "This app is similar to urban company. It provides services and users can also join as a seller and list their services and get paid directly into their stripe account.",
    link: "https://urban-services.netlify.app/",
    isExternal: true
  },
  {
    id: 3,
    img: "https://i.ibb.co/bJtkmRC/Screenshot-50.png",
    title: "Studio Ghibli Universe",
    description: "Studio Ghibli is a multi-user level fullstack ANIME app where a user can book a service and buy products, a seller can manage all his bookings, orders and products.",
    link: "https://studio-ghibli-universe.herokuapp.com/home",
    isExternal: true
  },
  {
    id: 4,
    img: "https://i.ibb.co/qkY6Fd5/Screenshot-4.png",
    title: "Know Air Quality Index(AQI)",
    description: "This app provides real time Air quality index of your city and your area.",
    link: "https://aqi-react.netlify.app/",
    isExternal: true
  },
  {
    id: 5,
    img: "https://i.ibb.co/ScYfC1m/hotel1.png",
    title: "Plan Your Trip - hotel system",
    description: "Online hotel booking and planning your trips App with the help of React js.",
    link: "/post2",
    isExternal: false
  },
  {
    id: 6,
    img: "https://i.ibb.co/xL0yfNr/m-tube1.png",
    title: "M-Tube",
    description: "Created an App Similar to YouTube app using youtube API with React js and Redux.",
    link: "/post3",
    isExternal: false
  }
];

// Post 1 - Food Delivery App
export const POST1_IMAGES = {
  main: "https://i.ibb.co/z2wyYmB/food1.png",
  types: "https://i.ibb.co/pxqS7zR/food2.png",
  appStore: "https://i.ibb.co/f8bFqyq/food3.png",
  locations: "https://i.ibb.co/g7NQzbZ/food4.png",
  about: "https://i.ibb.co/TYCzfQK/food5.png",
  footer: "https://i.ibb.co/QKsKWDc/food6.png"
};

// Post 2 - Hotel Booking
export const POST2_IMAGES = {
  main: "https://i.ibb.co/ScYfC1m/hotel1.png",
  home: "https://i.ibb.co/6BmLN6m/hotel7.png",
  search: "https://i.ibb.co/XZ5BpDq/hotel6.png",
  details: "https://i.ibb.co/48PWb1T/hotel2.png",
  booking: "https://i.ibb.co/sQQ2ZTk/hotel3.png",
  login: "https://i.ibb.co/GJn0RD1/hotel4.png",
  signup: "https://i.ibb.co/GWXBTfS/hotel5.png"
};

// Post 3 - M-Tube
export const POST3_IMAGES = {
  main: "https://i.ibb.co/jf2dWSj/m-tube1.png",
  home: "https://i.ibb.co/BqR41np/m-tube2.png",
  search: "https://i.ibb.co/FgPgCJF/m-tube3.png",
  video: "https://i.ibb.co/ggnMGTV/m-tube4.png",
  trending: "https://i.ibb.co/Trrx5cC/m-tube5.png",
  sidebar: "https://i.ibb.co/28k58g7/m-tube6.png"
};

// Skills data
export const SKILLS = {
  primary: ["JavaScript", "TypeScript", "Python", "Node", "React.js", "Redux.js", "Next.js", "HTML/CSS"],
  secondary: ["AgenticAI", "GenAI", "LLMs", "RAG", "OpenAI" , "Google Maps API", "JS Charts", "AWS (RDS/S3)"]
};

// Social links
export const SOCIAL_LINKS = {
  github: {
    url: "https://github.com/rahul-singh-au9",
    username: "rahul-singh-au9",
    display: "Github: @rahulsingh-au9"
  },
  linkedin: {
    url: "https://www.linkedin.com/in/rahul-singh-7b48901b1/",
    display: "Linkedin: @Rahul Singh"
  }
};

// Profile data
export const PROFILE = {
  name: "Rahul Singh",
  title: "Fullstack Developer",
  image: "https://avatars3.githubusercontent.com/u/67591334?s=400&u=2c332baf94419768b351135393cbf8482c855ecc&v=4",
  tagline: "I build new projects just to tickle my brain and love teaching others how they're made.",
  description: "While I keep busy building projects, I still try to interact with people in search of a great team & projects that interest me.",
  expertise: "Fullstack developer with primary focus on JavaScript + React"
};

// EmailJS configuration
export const EMAILJS_CONFIG = {
  serviceId: 'service_hiexk5o',
  templateId: 'template_8pr7mhv',
  userId: 'user_nfnzqRPjGcJhpsXZuYuFY'
};

